var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "QueryList",
    {
      attrs: {
        "page-title": _vm.$t("sfe.route.producttag"),
        "page-name": _vm.pageName,
        "api-module": _vm.apiModule,
        "query-dom-data": _vm.domData,
        "query-data": _vm.searchQuery,
        "table-buttons": _vm.tableButtons,
        "table-dom": _vm.tableDom,
        "list-api": _vm.listApi,
      },
    },
    [
      _c(
        "el-button",
        {
          directives: [
            {
              name: "FPermission",
              rawName: "v-FPermission",
              value: { pageName: _vm.pageName, list: ["EXPORT"] },
              expression: "{ pageName, list: ['EXPORT'] }",
            },
          ],
          attrs: { slot: "other-action", type: "primary", size: "small" },
          on: { click: _vm.downloadExcel },
          slot: "other-action",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("sfe.productTag.exportProductInfo")) +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }